module.exports = __webpack_public_path__ + "imgs/inventory.4e8228ac997f85ac345250390b0dba15.svg";